module.exports = __webpack_public_path__ + "static/media/background2.68886889.jpg";